<template>
	<Modal
		title="Credit Report Destination"
		:closeOnOverlayClick="false"
		:visible="visible"
		@close="onSupportCancel"
	>
		<template v-slot:body>
			<div class="credit-app-selection">
				<span
				    class="credit-app-selection__instructions"
					>Select the destination:</span
				>
			</div>
		</template>
		<template v-slot:footer>
			<ButtonSet>
				<template>
					<ButtonClassic
						variant="primary"
						labelText="Test"
						@click="onSupportSubmitTest"
					/>
					<ButtonClassic
						variant="secondary"
						labelText="Production"
						@click="onSupportSubmitProduction"
					/>
					<ButtonClassic
						variant="text"
						labelText="Cancel"
						@click="onSupportCancel"
					/>
				</template>
			</ButtonSet>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/shells/modal/modal.vue';
import ButtonSet from '@/components/forms/button/button-set.vue';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import viewMixin from '@/mixins/view-mixin';

export default {
	name: 'CreditApplicationSelection',
	mixins: [viewMixin],
	components: {
		Modal,
		ButtonSet,
		ButtonClassic
	},
	props: {
		visible: {
			type: Boolean,
			default: true
		},
	},
	created() {
		this.$emit('ready');
	},
	methods: {
		async onSupportSubmitTest() {
			let submitData = 'TEST';

			this.$emit('submit', submitData);
		},
		async onSupportSubmitProduction() {
			let submitData = 'PROD';
			

			this.$emit('submit', submitData);
		},
		onSupportCancel() {
			this.$emit('cancel');
		},
	}
};
</script>

<style lang="scss" scoped>
.credit-app-selection {
	width: clamp(350px, 350px, 400px);
	display: flex;
	flex-direction: column;

	@include mq($until: md) {
		width: 100%;
	}

	&__instructions {
		font-size: $txt-font-size;
	}
}
</style>
